import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import { useTranslate } from '@growtherapy/i18n';

import { useActiveBrand } from '../components/branding/useActiveBrand';
import { setAlertTitle, setDefaultFaviconAndTitle } from '../metadata';
import { pluralizeString } from '../utils';
import { numWaitingVisitorsAtom, totalUnreadMessageCountAtom } from './state';

function formatNotificationTitle(numberWaiting: number, unreadMessageCount: number): string {
  if (numberWaiting) {
    return `(${numberWaiting}) ${pluralizeString(numberWaiting, 'client')} waiting`;
  }
  if (unreadMessageCount) {
    return `(${unreadMessageCount}) ${pluralizeString(unreadMessageCount, 'message')}`;
  }
  return '';
}

export function useShowNotificationInFaviconAndTitle() {
  const activeBrand = useActiveBrand();
  const t = useTranslate();
  const unreadMessageCount = useAtomValue(totalUnreadMessageCountAtom);
  const numberWaiting = useAtomValue(numWaitingVisitorsAtom);

  useEffect(
    function showNotificationInFaviconAndTitle() {
      if (!numberWaiting && !unreadMessageCount) return setDefaultFaviconAndTitle(t, activeBrand);
      setAlertTitle(formatNotificationTitle(numberWaiting, unreadMessageCount), activeBrand);
    },
    [t, numberWaiting, unreadMessageCount, activeBrand],
  );
}
